module.exports = __webpack_public_path__ + "static/media/01.328ad41f.jpg";